import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGetData } from "../../hooks/useGetData"; 
import { AppCard } from "@dcam/dcam_flhealth_component_library";
import formsubmit from "../../assets/img/FormSubmitted.png";

interface ApiResponse {
  message?: string;
  details?: string;
}

const RegistrationSuccessEmail: React.FC = () => {
  const [status, setStatus] = useState<"LOADING" | "SUCCESS" | "FAIL">("LOADING");

  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");


  const { getDataById: getVerifyEmail } = useGetData<ApiResponse, string>(
    "HospitalRegistration/VerifyEmail",
    "GET"
  );

  useEffect(() => {
    if (!token) {
      setStatus("FAIL");
      return;
    }

    getVerifyEmail(`?token=${token}`)
      .then((response) => {
        setStatus("SUCCESS");
      })
      .catch((error) => {
        setStatus("FAIL");
      });
  }, []);

  return (
    <div className="mt-20">
      <AppCard>
        <div className="row">
          <div className="col col-md-12 text-center">
            <img
              className="img-fluid"
              src={formsubmit}
              alt="Form Submission"
              height="285px"
              width="450px"
            />
            <br />

            {status === "LOADING" && (
              <div style={{ fontSize: "16px", marginTop: "1rem" }}>
                Verifying your email, please wait...
              </div>
            )}

            {status === "SUCCESS" && (
              <>
                <div style={{ fontSize: "16px", marginTop: "1rem" }}>
                  Your Email has been Verified. Thank you!
                </div>
                <div style={{ fontSize: "16px" }}>
                  You may close the browser now.
                </div>
              </>
            )}

            {status === "FAIL" && (
              <>
                <div style={{ fontSize: "16px", marginTop: "1rem", color: "red" }}>
                  Verification Failed! The link might have expired.Please submit the form again.
                </div>
                <div style={{ fontSize: "16px" }}>
                  You may close the browser now.
                </div>
              </>
            )}
          </div>
        </div>
      </AppCard>
    </div>
  );
};

export default RegistrationSuccessEmail;
